// extracted by mini-css-extract-plugin
module.exports =  {"productImage":"r1F7dH","productBadge":"Ro2R77","badge":"B_c4yM","defaultImage":"aOKdEq"};